import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const MotorType = ({ motorType }: SpecProps<"motor_type">) => {
  const { i18n } = useLingui();

  if (!motorType) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.motor",
    message: "Motor type",
    comment: "Field for 'motor type' in ad specification",
  });
  return <FieldValuePair field={field} value={motorType} />;
};
